export const pertimbangan6 = {
  router: [
    {
      name: "REALISASI ANGGARAN BELANJA MODAL",
      key: "strategi_pengawasan_pb",
      path: "/admin/ppbr/strategi-pengawasan",
      apiUrl: {
        data: "ppbr/api/resiko/area/enam/",
        preview: "ppbr/api/resiko/area/enam/",
      },
      breadCrumb: [
        {
          label: "PPBR",
          link: "#",
          active: false,
        },
        {
          label: "PENILAIAN KEMATANGAN MR",
          link: "#",
          active: false,
        },
        {
          label: "REALISASI ANGGARAN BELANJA MODAL",
          link: "#",
          active: true,
        },
      ],
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "auditee_nama",
      label: "Area Pengawasan (Auditable Unit)",
      isForm: false,
      isTable: true,
      type: "label",
    },
    {
      name: "tahun",
      label: "Tahun",
      type: "number",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi angka",
          },
        ],
      },
      isForm: true,
      isTable: false,
    },
    {
      name: "realisasi",
      label: "Realisasi Anggaran Belanja Modal (%)",
      type: "number",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi angka",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
    {
      name: "skala",
      label: "Skala",
      type: "number",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi angka",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
